module.exports = __webpack_public_path__ + "static/img/bzkf_newcopy2@3x.534acdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/im/bzkf_newcopy2@3x.png
// module id = 3jCv
// module chunks = 1